import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d5271e0")

_pushScopeId("data-v-7d5271e0")
const _hoisted_1 = { class: "ui__defectPhoto_main" }
const _hoisted_2 = { class: "def_swiper-container" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (def) => {
          return (_openBlock(), _createBlock("div", {
            class: "swiper-slide",
            key: def.defectValue
          }, [
            _createVNode("h3", null, _toDisplayString(def.defectValue || def.congValue), 1),
            _createVNode("h3", null, _toDisplayString(def.confValueForeign), 1),
            _withDirectives(_createVNode("p", null, "解释： " + _toDisplayString(def.explain), 513), [
              [_vShow, def.explain]
            ]),
            _withDirectives(_createVNode("p", null, "Explanation： " + _toDisplayString(def.explainForeign), 513), [
              [_vShow, def.explainForeign]
            ])
          ]))
        }), 128))
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (s, index) => {
        return (_openBlock(), _createBlock("span", {
          key: String(index)+s.defectValue,
          class: ["pagination_item", {"pagination_active": index === _ctx.state.defectSlideIndex}]
        }, null, 2))
      }), 128))
    ], 512), [
      [_vShow, _ctx.dataList.length>1]
    ])
  ]))
})